import React from "react";
import { Paper, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useLocale } from "../../context/LocaleContext";
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import CurrencyExchangeRoundedIcon from '@mui/icons-material/CurrencyExchangeRounded';

export default function Selector({ action, setAction }) {
	const { messages } = useLocale();
	const handleChange = (event, newAction) => {
		if (newAction !== null) {
			setAction(newAction)
		}
	}
	return (
		<ToggleButtonGroup
			value={action}
			exclusive
			onChange={handleChange}
			fullWidth
			sx={{ marginBottom: "10px" }}
		>
		<Paper elevation={3} sx={{ width: "100%", flexDirection: "row", display: "flex" }}>
			<ToggleButton value="transaction" sx={{ padding: "10px" }}>
				<Stack flexDirection="row" gap={1} justifyContent="center" alignItems="center">
					<CurrencyExchangeRoundedIcon />
					<Typography fontSize="13px">{messages.barcode.transaction}</Typography>
				</Stack>
			</ToggleButton>
			<ToggleButton value="item" sx={{ padding: "10px" }}>
				<Stack flexDirection="row" gap={1} justifyContent="center" alignItems="center">
					<CategoryOutlinedIcon />
					<Typography fontSize="13px">{messages.barcode.items}</Typography>
				</Stack>
			</ToggleButton>
		</Paper>
		</ToggleButtonGroup>
	);
}